import { render } from "./SeverTransCourierDeliveryBanner.vue?vue&type=template&id=764851f0&scoped=true"
import script from "./SeverTransCourierDeliveryBanner.vue?vue&type=script&lang=js"
export * from "./SeverTransCourierDeliveryBanner.vue?vue&type=script&lang=js"

import "./SeverTransCourierDeliveryBanner.vue?vue&type=style&index=0&id=764851f0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-764851f0"]])

export default __exports__